import { BreadCrumb } from '@/components/app-header/helpers';
import { LoadState } from '@/lib/helpers';
import { AuthType, AuthUser } from '@/lib/services/auth.service';
import { createContext } from 'react';
import Lockup from '@/assets/f5-wais-light.svg';
import { BrandingModel } from '@/lib/models/branding.model';
import { getCachedBranding } from '@/lib/services/branding.service';

export interface AppSettings {
  loadState: LoadState;
  signedIn: boolean;
  signIn: (authUser: AuthUser, authType: AuthType) => boolean;
  signOut: () => Promise<boolean>;
  resetSignIn: () => boolean;
  // Re-run the boot-time auth check after a sign-in that happened without a redirect.
  reloadAuth: () => void;
  signInError: string;
  signInMethod: AuthType | null;
  pageTitle: { plain: string; breadcrumb?: BreadCrumb | BreadCrumb[] };
  setPageTitle: (title: string, breadcrumb?: BreadCrumb | BreadCrumb[]) => void;
  user: AuthUser | null;
  branding: BrandingModel;
}

const CachedBranding = getCachedBranding();

export const SpBranding = new BrandingModel({
  name: 'F5 Workforce AI Security',
  supportEmail: '',
  lightThemeLogo: Lockup,
  favicon: '/f5-favicon.svg',
});

export const DefaultBranding = CachedBranding?.enabled ? CachedBranding : SpBranding;

export const AppContext = createContext<AppSettings>({
  loadState: 'unloaded',
  signedIn: false,
  signInError: '',
  signInMethod: null,
  signIn: () => false,
  signOut: () => Promise.resolve(false),
  resetSignIn: () => false,
  reloadAuth: () => null,
  user: null,
  pageTitle: { plain: '' },
  setPageTitle: () => null,
  branding: DefaultBranding,
});
